import React from 'react';
import './PrivacyPolicy.css'; // Стилі

const PrivacyPolicy = () => {
  return (
    <div className='privacy-container'>
      <h1>Політика конфіденційності</h1>
      <p>
        <strong>Угода використання мобільного застосунку ÓFFER.</strong>
      </p>

      <section>
        <h2>1. Загальні положення</h2>
        <p>
          1.1 Ця Угода користування мобільним застосунком (далі — «Угода»)
          встановлює умови використання мобільного застосунку (далі —
          «Застосунок») ФОП Котвицький О.Є (далі — «Компанія») та є юридично
          зобов'язуючим документом між Компанією та користувачем Застосунку
          (далі — «Користувач»).
        </p>
        <p>
          1.2 Компанія надає Користувачеві доступ до функціоналу Застосунку,
          який дозволяє перегляд та замовлення товарів, інформаційних
          повідомлень, участь у програмах лояльності тощо. Використовуючи
          Застосунок, Користувач підтверджує ознайомлення та згоду з умовами
          цієї Угоди. У разі незгоди з будь-яким з положень цієї Угоди,
          Користувач зобов'язується припинити використання Застосунку.
        </p>
        <p>
          1.3 Застосунок виступає як інформаційно-комунікаційна платформа, 
          що забезпечує можливість пошуку, зв’язку та обміну інформацією між 
          користувачами. Компанія не контролює зміст домовленостей, обсяг 
          робіт чи умови співпраці між сторонами. Компанія не гарантує 
          якість, повноту чи відповідність послуг, які надаються майстрами, 
          автомагазинами або іншими зареєстрованими користувачами. 
          Відповідальність за виконання, своєчасність і якість таких послуг 
          повністю покладається на відповідних виконавців.
        </p>
        <p>
          1.4 Угода поширюється виключно на використання Застосунку. Умови
          використання сторонніх ресурсів, на які може бути здійснено перехід
          через Застосунок, регулюються окремими політиками конфіденційності та
          умовами користування таких ресурсів.
        </p>
        <p>
          1.5 Компанія залишає за собою право вносити зміни до цієї Угоди. Усі
          зміни набирають чинності з моменту їх опублікування в Застосунку.
          Продовження використання Застосунку після внесення змін означає згоду
          Користувача з оновленими умовами.
        </p>
      </section>

      <section>
        <h2>2. Персональні дані Користувача</h2>
        <p>
          2.1 У рамках цієї Угоди Компанія може збирати, зберігати, обробляти та
          використовувати персональні дані Користувача, включаючи, але не
          обмежуючись: ПІБ, електронну адресу, номер телефону, адресу доставки,
          дату народження, інформація про замовлення, історією взаємодій із
          Застосунком, а також іншими даними, що передаються Користувачем під
          час використання функціоналу Застосунку. Компанія може збирати
          технічну інформацію про пристрій Користувача, у тому числі IP-адресу,
          тип браузера, версію, унікальні ідентифікатори тощо.
        </p>
        <p>
          2.2 Компанія зобов'язується забезпечити конфіденційність і захист
          персональних даних відповідно до чинного законодавства України та
          внутрішньої Політики конфіденційності.
        </p>
        <p>
          2.3 Користувач має право на доступ, зміну, видалення своїх
          персональних даних, а також відкликання згоди на обробку.
        </p>
        <p>
          2.4 Користувач зобов'язується надавати достовірну інформацію та не
          використовувати додаток з протиправною метою.
        </p>
      </section>

      <section>
        <h2>
          3. Доступ до застосунку та його використання. Право інтелектуальної
          власності
        </h2>
        <p>
          3.1 Застосунок надається Користувачеві для особистого використання
          відповідно до його функціональних можливостей. Користувач приймає на
          себе зобов'язання дотримуватися умов цієї Угоди, не порушуючи при
          цьому права та законні інтереси Компанії.
        </p>
        <p>
          3.2 У разі порушення прав інтелектуальної власності, Користувач несе
          відповідальність за вчинені порушення відповідно до чинного
          законодавства України.
        </p>
      </section>

      <section>
        <h2>4. Оплата та повернення коштів</h2>
        <p>
          4.1 У застосунку можуть надаватися платні цифрові послуги та{' '}
          <strong>замовлення товарів через маркетплейс</strong>.
        </p>
        <p>
          4.2 Оплата здійснюється через інтегрований платіжний сервіс LiqPay.
        </p>
        <p>
          4.3 У разі технічного збою або помилкового списання коштів Користувач
          має право звернутися з відповідним запитом на електронну адресу служби
          підтримки Компанії протягом 7 календарних днів з моменту платежу.
        </p>
        <p>
          4.4 Повернення коштів можливе лише за умови, якщо платна послуга не 
          була активована або використана. У разі спірної ситуації Користувач 
          має звернутися до служби підтримки для розгляду запиту.
        </p>
        <p>
          4.5 Компанія не є стороною фінансових операцій, які здійснюються між 
          користувачами застосунку, зокрема між клієнтами, майстрами чи 
          представниками автомагазинів. Усі платежі, передоплати, повернення 
          коштів чи інші розрахунки відбуваються на власний ризик сторін, 
          що беруть у них участь. Компанія не несе відповідальності за будь-які 
          збитки, втрати чи претензії, що можуть виникнути внаслідок таких 
          фінансових операцій, у тому числі через шахрайські дії, затримки 
          платежів або невиконання домовленостей між користувачами.
        </p>
      </section>

      <section>
        <h2>5. Контактна інформація</h2>
        <p>
          5.1 Для запитань щодо цієї Угоди або обробки персональних даних
          Користувач може звернутися до служби підтримки Компанії:{' '}
          <a href='mailto:offerappreact@gmail.com'>
            <strong>offerappreact@gmail.com</strong>
          </a>
          .
        </p>
        <p>
          <strong>ФОП Котвицький Олександр Євгенійович</strong>
          <br />
          ЄДРПОУ: 3371716519
          <br />
          вул. Роменська 71, м. Суми, Україна
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;